import Swiper from "swiper";

const productInfoSwiper = new Swiper(document.querySelector(".product-info"), {
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
  },
});

export default productInfoSwiper;
